import { jsonMember, jsonObject } from 'typedjson';
import { Uuid } from '@core/uuid/uuid';

@jsonObject
export class CreateResourceResponse {
  @jsonMember readonly id!: Uuid;
}
